import React from 'react';
import { Search } from 'lucide-react';
import { useRightSidebar } from '../contexts/RightSidebarContext';

interface FloatingSearchButtonProps {
  isSearchVisible: boolean;
  setIsSearchVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
  isFocusMode: boolean;
  hasMainAreaView: boolean;
  t: (key: string) => string;
}

export const FloatingSearchButton: React.FC<FloatingSearchButtonProps> = React.memo(({
  isSearchVisible,
  setIsSearchVisible,
  isMobile,
  isFocusMode,
  hasMainAreaView,
  t,
}) => {
  let rightSidebar;
  try {
    rightSidebar = useRightSidebar();
  } catch {
    rightSidebar = null;
  }

  if (isFocusMode) {
    return null;
  }

  if (hasMainAreaView) {
    return null;
  }

  const topPosition = isFocusMode
    ? 'calc(1rem + 40px + 0.5rem)'
    : 'calc(64px + 1rem)';
  const rightPosition = isMobile ? '1.8rem' : '4rem';

  return (
    <button
      className="floating-editor-control"
      onClick={() => {
        setIsSearchVisible((prev) => !prev);
      }}
      style={{
        position: 'fixed',
        top: topPosition,
        right: rightPosition,
        zIndex: 1,
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: 'none',
        padding: 0,
        color: 'var(--muted-foreground)',
        opacity: isSearchVisible ? 0 : 1,
        transition: 'opacity 0.2s, background-color 0.2s, box-shadow 0.2s',
        pointerEvents: isSearchVisible ? 'none' : 'auto',
      }}
      aria-label={t('search_in_document') || 'Search in document'}
    >
      <Search className="h-5 w-5" style={{ color: 'currentColor' }} />
    </button>
  );
});

FloatingSearchButton.displayName = 'FloatingSearchButton';
